import React from 'react';

// ui
import Avatar from '@material-ui/core/Avatar';
import GroupIcon from '@material-ui/icons/Group';
import PinIcon from '@material-ui/icons/Place';

// utils
import { getInitials } from '.';

export default (entity, styles) => {
  let avatarComponent;

  if (entity?.gravatar) {
    avatarComponent = <Avatar className={styles.avatar} src={entity.gravatar} />;
  } else {
    let avatarContent;

    switch (entity?.type) {
      case 'site':
        avatarContent = <PinIcon />;
        break;
      case 'scope':
      case 'department':
        avatarContent = <GroupIcon />;
        break;
      case 'callqueue':
        avatarContent = <span className="nsicon-m nsicon-m-nav-queues" />;
        break;
      case 'subscriber':
        avatarContent = (
          <span>
            {getInitials(entity.name).slice(0, 2)}
          </span>
        );
        break;
      default: // shouldn't get here
        avatarContent = (<span>Err</span>);
        break;
    }

    avatarComponent = (
      <div className={styles.initials}>
        {avatarContent}
      </div>
    );
  }

  return avatarComponent;
};
